import * as React from 'react';

import { type VariantProps, cva } from 'class-variance-authority';

import { cn } from '../lib/utils';

const alertVariants = cva(
  'vai-font-inter vai-relative vai-w-full vai-rounded-lg vai-border vai-p-4 [&>svg~*]:vai-pl-7 [&>svg+div]:vai-translate-y-[-3px] [&>svg]:vai-absolute [&>svg]:vai-left-4 [&>svg]:vai-top-4 vai-grid vai-items-start [&>svg]:vai-gap-x-4 [&>svg]:vai-size-4',
  {
    variants: {
      variant: {
        default:
          'vai-bg-background vai-text-foreground [&>svg]:vai-text-foreground',
        destructive:
          'vai-border-destructive/50 vai-text-destructive dark:vai-border-destructive [&>svg]:vai-text-destructive',
        success:
          'vai-border-green-500/50 vai-text-green-500 dark:vai-border-green-500 [&>svg]:vai-text-green-500',
        warning:
          'vai-border-amber-500/50 vai-text-amber-700 dark:vai-border-amber-500 dark:vai-text-amber-200 [&>svg]:vai-text-amber-600 dark:[&>svg]:vai-text-amber-400',
        destructiveSolid:
          'vai-bg-red-800 vai-border-none vai-text-zinc-50 [&>div]:vai-text-zinc-50/80',
        successSolid:
          'vai-bg-green-700 vai-border-none vai-text-zinc-50 [&>div]:vai-text-zinc-50/80',
        warningSolid:
          'vai-bg-amber-600 vai-border-none vai-text-zinc-50 [&>div]:vai-text-zinc-50/80',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

const Alert = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & VariantProps<typeof alertVariants>
>(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    role="alert"
    className={cn(alertVariants({ variant }), className)}
    {...props}
  />
));
Alert.displayName = 'Alert';

const AlertTitle = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, children, ...props }, ref) => (
  <h5
    ref={ref}
    className={cn(
      'vai-mb-1 vai-font-medium vai-leading-none vai-tracking-tight',
      className,
    )}
    {...props}
  >
    {children}
  </h5>
));
AlertTitle.displayName = 'AlertTitle';

const AlertDescription = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('vai-text-sm [&_p]:vai-leading-relaxed', className)}
    {...props}
  />
));
AlertDescription.displayName = 'AlertDescription';

export { Alert, AlertTitle, AlertDescription };
